import { apiClient } from './api'

export interface ProjectGovernanceResponse {
  id: number
  project_id: number
  governance_data: Record<string, unknown> | null
  created_at: string | null
  updated_at: string | null
}

export const projectGovernanceService = {
  get(projectId: number): Promise<ProjectGovernanceResponse> {
    return apiClient.get(`/api/v1/projects/${projectId}/governance/`).then((r) => r.data)
  },
  update(projectId: number, governance_data: Record<string, unknown>): Promise<ProjectGovernanceResponse> {
    return apiClient.patch(`/api/v1/projects/${projectId}/governance/`, { governance_data }).then((r) => r.data)
  },
}
